export function teamOwnersLabel(teams: string[]): string {
    return `${teams.length === 1 ? 'Owner' : 'Owners'}: ${teams.join(', ')}`;
}
